(function () {
  'use strict';
 
  if (window.__MP_PRICE_STRIKER_BOOTED__) return;
  window.__MP_PRICE_STRIKER_BOOTED__ = true;

  var DISCOUNT_MAP = {
    '20OFFLTO': 0.20
    // add more codes here
  };
 
  // Slow safety net in case a cart event is missed. v1 effectively polled
  // every 750ms. 20s is plenty for a display-only feature. Set to 0 to
  // disable polling entirely once you're happy with the events.
  var SAFETY_POLL_MS = 20000;
 
  var PRICE_SELECTORS = {
    grid:    '.grid-product__price',
    variant: '.var_prc',
    product: '.product__price .price-item--regular, .product-single__price'
  };
 
  var cartFetch     = window.fetch.bind(window);
  var appliedPct    = 0;
  var isChecking    = false;
  var isPainting    = false;
  var checkTimer    = null;
  var pollTimer     = null;
 
  function parseMoney(text) {
    var match = String(text).match(/\$\s*([0-9][0-9.,]*)/);
    if (!match) return null;
    var value = parseFloat(match[1].replace(/,/g, ''));   // ALL commas
    return isNaN(value) ? null : value;
  }
 
  function fmt(value) {
    return '$' + value.toFixed(2);
  }
 
  function percentFromCookie() {
    var match = document.cookie.match('(^|;)\\s*discount_code\\s*=\\s*([^;]+)');
    if (!match) return 0;
    var code = decodeURIComponent(match.pop()).toUpperCase();
    return DISCOUNT_MAP[code] || 0;
  }
 
  function percentFromCart(cart) {
    var code = null;
 
    var cartLevel = cart.cart_level_discount_applications || [];
    if (cartLevel.length) code = cartLevel[0].title;
 
    // Line-level (Abra compatibility)
    if (!code && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        var allocations = cart.items[i].line_level_discount_allocations || [];
        if (!allocations.length) continue;
        var app = allocations[0].discount_application;
        if (app && app.title) { code = app.title; break; }
      }
    }
 
    if (!code) return 0;
    return DISCOUNT_MAP[String(code).toUpperCase()] || 0;
  }
 

  function restore(el) {
    if (typeof el.dataset.psOriginal === 'string') {
      el.innerHTML = el.dataset.psOriginal;
    }
    delete el.dataset.psOriginal;
    delete el.dataset.psApplied;
  }
 
  // Returns false if this element is already correct and can be skipped.
  function prepare(el, percent) {
    var tag = String(percent);
    if (el.dataset.psApplied === tag) return false;
    if (el.dataset.psApplied) restore(el);          // percent changed
    el.dataset.psOriginal = el.innerHTML;
    el.dataset.psApplied  = tag;
    return true;
  }
 
  function paintGrid(percent) {
    document.querySelectorAll(PRICE_SELECTORS.grid).forEach(function (container) {
      var saleEl     = container.querySelector('.grid-product__price--sale');
      var originalEl = container.querySelector('.grid-product__price--original');
      var source     = saleEl ? saleEl.textContent : container.textContent;
 
      var raw = parseMoney(source);
      if (raw === null) return;
      if (!prepare(container, percent)) return;
 
      var next = raw * (1 - percent);
 
      // Re-query: prepare() may have restored the original markup.
      saleEl     = container.querySelector('.grid-product__price--sale');
      originalEl = container.querySelector('.grid-product__price--original');
 
      if (originalEl && saleEl) {
        // Already on sale natively — just rewrite the sale number.
        var moneySpan = saleEl.querySelector('.money');
        if (moneySpan) moneySpan.textContent = fmt(next);
        else saleEl.textContent = fmt(next);
        return;
      }
 
      container.innerHTML =
        '<span class="grid-product__price--original" style="text-decoration: line-through; color: #999; margin-right: 5px;">' +
          '<span class="money">' + fmt(raw) + '</span>' +
        '</span>' +
        '<span class="grid-product__price--sale" style="color: #d02e2e;">' +
          '<span class="money">' + fmt(next) + '</span>' +
        '</span>';
    });
  }
 
  function paintSimple(selector, percent, gap) {
    document.querySelectorAll(selector).forEach(function (container) {
      var raw = parseMoney(container.textContent);
      if (raw === null) return;
      if (!prepare(container, percent)) return;
 
      var next = raw * (1 - percent);
      container.innerHTML =
        '<s style="color: #999; margin-right: ' + gap + ';">' + fmt(raw) + '</s>' +
        '<span style="color:#d02e2e;">' + fmt(next) + '</span>';
    });
  }
 
  function applyDiscounts(percent) {
    isPainting = true;
    try {
      paintGrid(percent);
      paintSimple(PRICE_SELECTORS.variant, percent, '5px');
      paintSimple(PRICE_SELECTORS.product, percent, '8px');
      appliedPct = percent;
    } catch (err) {
      console.error('Price Striker paint error:', err);
    } finally {
      isPainting = false;
    }
  }
 
  function revertPrices() {
    isPainting = true;
    try {
      document.querySelectorAll('[data-ps-applied]').forEach(restore);
      appliedPct = 0;
    } finally {
      isPainting = false;
    }
  }
 
  function render(percent) {
    if (percent > 0) applyDiscounts(percent);
    else if (appliedPct > 0 || document.querySelector('[data-ps-applied]')) revertPrices();
  }
 
  /* ------------------------------------------------------------------
   * CART CHECK
   * ---------------------------------------------------------------- */
 
  function checkNow() {
    if (isChecking) return Promise.resolve();
    isChecking = true;
 
    return cartFetch('/cart.js?_=' + Date.now(), {
      method: 'GET',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // RESET every pass — this is the bug that could leave a fake
        // struck-through price on screen after the discount was gone.
        var percent = percentFromCart(cart);
        render(percent);
      })
      .catch(function (err) {
        console.error('Price Striker Error:', err);
      })
      .finally(function () {
        isChecking = false;
      });
  }
 
  function scheduleCheck(delay) {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(checkNow, typeof delay === 'number' ? delay : 400);
  }
 
  function wireEvents() {
    ['cart:refresh', 'cart:build', 'cart:update', 'cart:change'].forEach(function (name) {
      document.addEventListener(name, function () { scheduleCheck(400); });
      document.documentElement.addEventListener(name, function () { scheduleCheck(400); });
    });
 
    document.addEventListener('shopify:section:load', function () { scheduleCheck(200); });
    window.addEventListener('pageshow', function () { scheduleCheck(0); });
 
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) scheduleCheck(0);
    });
 
    // Variant tiles: the theme rewrites the price with jQuery on click.
    // Repaint from the theme's fresh markup.
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('.variant-tile, .variant-tile-disc, .fil-variant')) {
        setTimeout(function () { if (appliedPct > 0) applyDiscounts(appliedPct); }, 60);
      }
    });
 
    // Catches lazy-loaded grids, quick-add modals and drawer re-renders
    // without polling. Our own writes are ignored via isPainting.
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (isPainting || appliedPct <= 0 || pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          applyDiscounts(appliedPct);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
 
    if (SAFETY_POLL_MS > 0) {
      pollTimer = setInterval(function () {
        if (!document.hidden) checkNow();
      }, SAFETY_POLL_MS);
    }
  }
 
  /* ------------------------------------------------------------------
   * BOOT
   * ---------------------------------------------------------------- */
 
  function boot() {
    // Cookie first for an instant paint (no visual lag), then verify
    // against the real cart.
    var instant = percentFromCookie();
    if (instant > 0) applyDiscounts(instant);
 
    wireEvents();
    checkNow();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();   // v1 died silently in this case
  }
})();